import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=bb8613fe&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb8613fe')) {
      api.createRecord('bb8613fe', component.options)
    } else {
      api.reload('bb8613fe', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=bb8613fe&", function () {
      api.rerender('bb8613fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-297P2bNeMCZFn/JS/comp/FavElement.vue"
export default component.exports